import { getAccessToken, httpClient, request } from './http';
import type { PaginatedResult } from '@/types/api';
import type {
  UpstreamCheckFindingItem,
  UpstreamCheckFindingQuery,
  UpstreamCheckSampleDetail,
  UpstreamCheckSampleItem,
  UpstreamCheckSetting,
} from '@/types/upstreamCheck';

export const adminUpstreamCheckApi = {
  getSetting() {
    return request<UpstreamCheckSetting>({
      url: '/admin/upstream-check/setting',
      method: 'GET',
    });
  },

  updateSetting(enabled: boolean) {
    return request<UpstreamCheckSetting>({
      url: '/admin/upstream-check/setting',
      method: 'PATCH',
      data: { enabled },
    });
  },

  listFindings(query?: UpstreamCheckFindingQuery) {
    return request<PaginatedResult<UpstreamCheckFindingItem>>({
      url: '/admin/upstream-check/findings',
      method: 'GET',
      params: query,
    });
  },

  listSamples(page = 1, pageSize = 20) {
    return request<PaginatedResult<UpstreamCheckSampleItem>>({
      url: '/admin/upstream-check/samples',
      method: 'GET',
      params: { page, pageSize },
    });
  },

  sampleDetail(id: string) {
    return request<UpstreamCheckSampleDetail>({
      url: `/admin/upstream-check/samples/${id}`,
      method: 'GET',
    });
  },

  clearAll() {
    return request<{ findingsDeleted: number; samplesDeleted: number }>({
      url: '/admin/upstream-check/findings',
      method: 'DELETE',
      params: { confirm: true },
    });
  },

  async downloadExport(): Promise<void> {
    const token = getAccessToken();
    const resp = await httpClient.get('/admin/upstream-check/export', {
      responseType: 'blob',
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    });
    const disposition = String(resp.headers['content-disposition'] || '');
    const match = /filename="?([^"]+)"?/.exec(disposition);
    const filename = match?.[1] || `DRIFT-PACK-${Date.now()}.md`;
    const blob = new Blob([resp.data], { type: 'text/markdown;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },
};
